import { DEV } from 'cc/env';
import { Label, Node, _decorator } from 'cc';
import GameDependency from '../../../System/GameDependency';
import { fillTextArgument } from '../../Utils/Utility';

const { ccclass, property, requireComponent } = _decorator;

@ccclass('VersionText')
@requireComponent(Label)
export default class VersionText extends GameDependency {
    @property({ tooltip: DEV && '顯示版本號的文字模板 (ex. textTemplate = v{0}, version = 1.0.0, output = v1.0.0)' })
    private readonly textTemplate: string = 'v{0}';
    @property({ type: Node, tooltip: DEV && '當 hideVersion 時, 連帶隱藏哪個節點' })
    private readonly rootNode: Node = null;

    protected start() {
        this.getComponent(Label).string = fillTextArgument(this.textTemplate, [this.game.config.gameVersion]);
        if (this.game.config.hideVersion) {
            if (this.rootNode) {
                this.rootNode.active = false;
            }
            this.node.active = false;
        }
    }
}
